import React from 'react'
import SabaFlag from 'components/common/SabaFlag'
import CuracaoFlag from 'components/common/CuracoFlag'

const iconSet = new Map([
  ['Saba', SabaFlag],
  ['Curaçao', CuracaoFlag]
])

const flagIconGenerator = (type) => {
  const Icon = iconSet.get(type)

  if (Icon) {
    return <Icon className="min-w-[3rem] min-h-[3rem]" />
  }

  return null
}
export default flagIconGenerator
